import React, {useState, useRef} from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Popover,
    useMediaQuery
} from "@material-ui/core";
import Strings from './../lang/Strings';
import {useWelcomeStyle} from '../styles/WelcomeStyle';
import clsx from 'clsx'
import Button from '@material-ui/core/Button';
import MoreIcon from '@material-ui/icons/Menu';
import FeatureItem from "../views/FeatureItem";
import CloseIcon from "@material-ui/icons/Close"
import AppIconSection from "../views/AppIcon";
import {useTheme} from '@material-ui/core/styles';
import MiniAuthView from "../auth/MiniAuthView";
import WhiteFeaturesPopUpView from "../views/WhiteFeaturesPopUpView";
import {Constants} from '../constants/Constants';
import OnBoarder from "./OnBoarder";
import Dimens from './../dimensions/Dimens';
import FinancialFutureTicketView from "./FinancialTicketView";
import FullFeaturesList from "./FullFeaturesList";
import WhatIsBitcoinOnBoardingView from "./WhatIsBitcoinOnBoardingView";
import WalletExistenceOnBoardingView from "./WalletExistenceOnBoardingView";
import EnterTheFutureOfInvestmentView from "./EnterTheFutureOfInvestmentView";
import OnBoardingFooterView from "./OnBoardingFooterView";
import {NumberUtils} from '../utils/NumberUtils';
import {Redirect} from "react-router-dom";
import Routes from './../constants/Routes';
import CookieConsent from "react-cookie-consent";
import AppColors from './../colors/AppColors';
import {animateScroll} from "react-scroll";

export default function Welcome(props: any) {

    const appInitData = props.data;
    const featuresRef = useRef(null);

    const [openMobileMenu, setOpenMobileMenu] = useState<boolean>(false);
    const [mobileMenuAnchor, setMobileMenuAnchor] = useState<HTMLElement | null>(null);
    const [featurePopUpAnchor, setFeaturePopUpAnchor] = useState<HTMLElement | null>(null);

    const classes = useWelcomeStyle();
    const theme = useTheme();
    const desktopMode: boolean = useMediaQuery(theme.breakpoints.between(750, Dimens.MAX_WIDTH))
    const averageDesktopMode: boolean = useMediaQuery(theme.breakpoints.between(999, Dimens.MAX_WIDTH))

    const [navigateToLogin, setNavigateToLogin] = useState(false);
    const [navigateToSignUp, setNavigateToSignUp] = useState(false);

    const scrollToRef = (ref: any) => {
        let refPosition: number = ref.current.offsetTop;
        animateScroll.scrollTo(refPosition)
    }

    const featuresRefClickHandler = () => {
        handleMobileMenuClose();
        handleFeaturesPopOverClose();
        scrollToRef(featuresRef);
    }

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setFeaturePopUpAnchor(event.currentTarget);
    }

    const handleFeaturesPopOverClose = () => {
        setFeaturePopUpAnchor(null);
    }

    const handleMobileMenuClose = () => {
        setMobileMenuAnchor(null);
        setOpenMobileMenu(false);
    }

    const handleMobileMenuItemClick = (event: any, newValue: boolean) => {
        setOpenMobileMenu(newValue);
        setMobileMenuAnchor(event.currentTarget);
    }

    const initLogin = () => {
        setNavigateToLogin(true);
    }

    const initSignUp = () => {
        setNavigateToSignUp(true);
    }

    const desktopAuthMenuOptions = (
        <div className={classes.sectionDesktop}>
            <Button
                style={{
                    color: 'white'
                }}
                onClick={initLogin}
                className={clsx(classes.desktopLogin, classes.loginButton)}
                variant={"outlined"}>
                {Strings.LOGIN_TEXT}
            </Button>
            <Button
                className={clsx(classes.authButton, classes.signUpButton)}
                onClick={initSignUp}>{Strings.SIGNUP_TEXT}</Button>
        </div>
    );

    const mobileMenuIcon = (
        <div className={clsx(classes.sectionMobile)}>
            <IconButton color="inherit" onClick={(event) => {
                handleMobileMenuItemClick(event, !openMobileMenu)
            }}>
                <MoreIcon/>
            </IconButton>
        </div>
    );

    const mobileMenu = (
        <Popover
            onClose={handleMobileMenuClose}
            open={Boolean(mobileMenuAnchor) && !desktopMode}
            className={classes.mobileMenu}
            anchorEl={mobileMenuAnchor}
            classes={{paper: classes.mobileMenuPaper}}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: 'inherit'}}>
                    <AppIconSection/>
                    <div style={{flexGrow: 1}}/>
                    <CloseIcon className={classes.closeIcon} onClick={() => (handleMobileMenuClose())}/>
                </div>
                <div style={{display: 'flex', flexWrap: 'wrap', padding: 20}}>
                    <Button className={classes.loginButton} variant={"outlined"}
                            onClick={initLogin}>{Strings.LOGIN_TEXT}</Button>
                    <Button className={classes.signUpPrimary} onClick={initSignUp}>{Strings.SIGNUP_TEXT}</Button>
                </div>
                <div style={{marginTop: 10}}/>
                <FeatureItem handler={featuresRefClickHandler} title="Win FREE BTC"
                             description={`Roll and Win Free Bitcoins every hour`}/>
                <FeatureItem handler={featuresRefClickHandler} title="Multiply BTC"
                             description={`Multiply your Bitcoins in seconds by playing our simple <span style="color:white;font-weight:600;">${Constants.MULTIPLY_BTC_GAME} Game</span>`}/>
            </div>
        </Popover>
    );

    return (
        !appInitData ?
            <Redirect to={Routes.DEFAULT}/> :
            <div style={{display: 'flex', flexDirection: 'column', overflowX: 'hidden'}}
                 onClick={() => handleFeaturesPopOverClose()}>
                {openMobileMenu && mobileMenu}
                <AppBar position="fixed" elevation={0} className={clsx(classes.appBar)}>
                    <Toolbar>
                        <AppIconSection/>
                        <Typography className={clsx(classes.features, classes.sectionDesktop)}
                                    onMouseEnter={handlePopoverOpen}
                                    onClick={handlePopoverOpen}
                        >{Strings.FEATURES}</Typography>
                        <Typography
                            className={clsx(classes.current_price, classes.sectionDesktop)}>{`1BTC = ${NumberUtils.formatInThousands(parseFloat(appInitData.currentBitcoinPrice))} ${appInitData.currentBitcoinCurrency}`}</Typography>
                        <div className={classes.grow}/>
                        {averageDesktopMode && <MiniAuthView/>}
                        {!averageDesktopMode && desktopAuthMenuOptions}
                        {mobileMenuIcon}
                    </Toolbar>
                    {featurePopUpAnchor && desktopMode &&
                    <WhiteFeaturesPopUpView anchor={featurePopUpAnchor} handler={featuresRefClickHandler}/>}
                </AppBar>
                <div className={classes.offset}>
                    <OnBoarder data={appInitData}/>
                    <FinancialFutureTicketView/>
                    <FullFeaturesList ref={featuresRef}/>
                    <WhatIsBitcoinOnBoardingView/>
                    <WalletExistenceOnBoardingView/>
                    <EnterTheFutureOfInvestmentView/>
                    <OnBoardingFooterView/>
                    {
                        navigateToLogin && <Redirect to={Routes.LOGIN}/>
                    }
                    {
                        navigateToSignUp && <Redirect to={Routes.SIGN_UP}/>
                    }
                    <CookieConsent location="bottom"
                                   buttonText="Got it!"
                                   cookieName={Constants.COOKIE_NAME}
                                   style={{background: AppColors.BLACK, color: 'white'}}
                                   buttonStyle={{color: "#4e503b", fontSize: "13px"}}>
                        This website uses cookies to collect information about how you interact with our website. We
                        use
                        this
                        information in order to improve and customize your browsing experience and for analytics and
                        metrics
                        about our visitors.</CookieConsent>
                </div>
            </div>
    );
}